import React from 'react'
import { Modal, Button, Radio } from 'antd'
import styles from './DeleteSectionModal.module.css'

const DeleteSectionModal = ({
    open,
    onCancel,
    onConfirm,
    deleteSectionData,
    deleteOption,
    setDeleteOption,
    confirmLoading = false,
}) => {
    const totalTasks = Number(deleteSectionData?.totalTasks) || 0
    const hasTasks = totalTasks > 0

    return (
        <Modal
            open={open}
            onCancel={confirmLoading ? undefined : onCancel}
            footer={null}
            closable={!confirmLoading}
            maskClosable={!confirmLoading}
            className={styles.deleteSectionModal}
            width={480}
            centered
        >
            <div className={styles.deleteSectionModalContent}>
                <h3 className={styles.deleteSectionModalTitle}>
                    Are you sure you want to delete this section?
                </h3>
                {deleteSectionData && (
                    <div className={styles.deleteSectionModalBody}>
                        {hasTasks ? (
                            <>
                                <p className={styles.deleteSectionInfo}>
                                    This section{' '}
                                    <strong>
                                        {deleteSectionData?.sectionName}
                                    </strong>{' '}
                                    includes {totalTasks} task
                                    {totalTasks !== 1 ? 's' : ''}.
                                </p>
                                <Radio.Group
                                    value={deleteOption}
                                    onChange={(e) =>
                                        setDeleteOption(e.target.value)
                                    }
                                    disabled={confirmLoading}
                                    className={styles.deleteSectionRadioGroup}
                                >
                                    <Radio
                                        value="keep"
                                        className={styles.deleteSectionRadio}
                                    >
                                        Delete this section and keep this{' '}
                                        {totalTasks} task
                                        {totalTasks !== 1 ? 's' : ''}
                                    </Radio>
                                    <Radio
                                        value="delete"
                                        className={styles.deleteSectionRadio}
                                    >
                                        Delete this section and delete this{' '}
                                        {totalTasks} task
                                        {totalTasks !== 1 ? 's' : ''}
                                    </Radio>
                                </Radio.Group>
                            </>
                        ) : (
                            <p className={styles.deleteSectionInfo}>
                                This section{' '}
                                <strong>
                                    {deleteSectionData?.sectionName}
                                </strong>{' '}
                                has no tasks. It will be permanently deleted.
                            </p>
                        )}
                    </div>
                )}
                <div className={styles.deleteSectionModalFooter}>
                    <Button
                        onClick={onCancel}
                        disabled={confirmLoading}
                        className={styles.deleteSectionCancelButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={onConfirm}
                        loading={confirmLoading}
                        disabled={confirmLoading}
                        className={styles.deleteSectionConfirmButton}
                    >
                        Delete section
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteSectionModal
